import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "m-2" }
const _hoisted_2 = { class: "row g-0 align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingArr, (state, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col text-center",
          key: index
        }, [
          _createVNode(_component_Icon, {
            icon: state ? _ctx.Star : _ctx.StarOutline,
            class: "text-warning",
            width: "1.3em",
            height: "1.3em"
          }, null, 8, ["icon"])
        ]))
      }), 128))
    ])
  ]))
}